import {useState} from "../../__snowpack__/pkg/react.js";
import {createModel} from "../../__snowpack__/pkg/hox.js";
import {axios} from "../lib/axios.js";
import {handleError} from "../lib/errorHandler.js";
export const fetchClaimProducts = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [userData, setUserData] = useState({});
  const fetchData = async (param) => {
    try {
      setIsLoading(true);
      const {data} = await axios.post(`/saas/cross-border/claim-products`, param);
      setUserData(data);
      return {userData: data};
    } catch (error) {
      handleError(error);
      return {userData: {}};
    } finally {
      setIsLoading(false);
    }
  };
  return {
    isLoading,
    fetchData,
    userData
  };
};
export const fetchProductCollect = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [userData, setUserData] = useState({});
  const fetchData = async (params) => {
    try {
      setIsLoading(true);
      const {data} = await axios.post(`/saas/cross-border/collect-products`, params);
      setUserData(data);
      return {userData: data};
    } catch (error) {
      handleError(error);
      return {userData: {}};
    } finally {
      setIsLoading(false);
    }
  };
  return {
    isLoading,
    fetchData,
    userData
  };
};
export const fetchGetCollectSetting = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [userData, setUserData] = useState({});
  const fetchData = async (sourceType) => {
    try {
      setIsLoading(true);
      const {data} = await axios.get(`/saas/cross-border/collect-setting/${sourceType}`);
      setUserData(data);
      return {userData: data};
    } catch (error) {
      handleError(error);
      return {userData: {}};
    } finally {
      setIsLoading(false);
    }
  };
  return {
    isLoading,
    fetchData,
    userData
  };
};
export const fetchDeleteDeleteCollectProduct = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [userData, setUserData] = useState({});
  const fetchData = async (param) => {
    try {
      setIsLoading(true);
      const data = await axios.post(`/saas/cross-border/delete-collect-products`, param);
      setUserData(data);
      return {userData: data};
    } catch (error) {
      handleError(error);
      return {userData: {}};
    } finally {
      setIsLoading(false);
    }
  };
  return {
    isLoading,
    fetchData,
    userData
  };
};
export const sassCrossBorderCollectSetting = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [userData, setUserData] = useState({});
  const fetchData = async (param) => {
    try {
      setIsLoading(true);
      const {data} = await axios.post(`/saas/cross-border/collect-setting`, param);
      setUserData(data);
      return {userData: data};
    } catch (error) {
      handleError(error);
      return {userData: {}};
    } finally {
      setIsLoading(false);
    }
  };
  return {
    isLoading,
    fetchData,
    userData
  };
};
export const fetchClaimProductsModal = createModel(fetchClaimProducts);
export const fetchProductCollectModal = createModel(fetchProductCollect);
export const fetchGetCollectSettingModal = createModel(fetchGetCollectSetting);
export const fetchDeleteDeleteCollectProductModal = createModel(fetchDeleteDeleteCollectProduct);
export const sassCrossBorderCollectSettingModal = createModel(sassCrossBorderCollectSetting);
